import { useEffect, useState } from 'react';
import { guessLang } from './useTranslate';

const needBigLineHeightLangs = ['my-MM', 'km-KH']; // 需要增大行间距的语种

export function useBigLineHeight() {
  const [lang, setLang] = useState<string>('');
  const needBigLineHeight = needBigLineHeightLangs.includes(lang);

  useEffect(() => {
    const setLocalLanguage = async () => {
      const guessedLang = await guessLang();
      setLang(guessedLang);
    };
    setLocalLanguage();
  }, []);

  return needBigLineHeight;
}